import { useEffect, useState } from 'react';
import { Brain } from '@phosphor-icons/react';
import { loadPrefs, savePrefs } from '@/lib/prefs';

export default function DeepReasoningToggle() {
  const [on, setOn] = useState(loadPrefs().deep);
  useEffect(() => {
    const h = (e) => setOn(!!e.detail?.deep);
    window.addEventListener('unmanip:prefs', h);
    return () => window.removeEventListener('unmanip:prefs', h);
  }, []);
  return (
    <button type="button" data-testid="deep-reasoning-toggle" aria-pressed={on}
      onClick={() => savePrefs({ ...loadPrefs(), deep: !on })}
      title="Deep reasoning: step-by-step logic, fallacies, hidden assumptions, alternatives"
      className={`inline-flex items-center gap-2 border px-3 py-2 text-[10px] uppercase tracking-[0.2em] transition-colors ${
        on ? 'border-violet-400 bg-violet-500/15 text-violet-300' : 'border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-zinc-200'}`}>
      <Brain weight={on ? 'fill' : 'bold'} className="h-4 w-4" /> deep reasoning {on ? 'on' : 'off'}
    </button>
  );
}
